import { apiClient } from "../lib/apiClient";
import type { AuthUser, ManagedUser, UserRole } from "../types";

export interface CreateUserInput {
  email: string;
  name: string;
  role: UserRole;
  password?: string;
}

export async function listUsers(): Promise<ManagedUser[]> {
  const { data } = await apiClient.get<{ users: ManagedUser[] }>("/users");
  return data.users;
}

export async function createUser(input: CreateUserInput): Promise<ManagedUser> {
  const { data } = await apiClient.post<{ user: ManagedUser }>("/users", input);
  return data.user;
}

export async function updateUser(
  id: string,
  input: Partial<{ name: string; role: UserRole; isActive: boolean; password: string | null }>,
): Promise<ManagedUser> {
  const { data } = await apiClient.patch<{ user: ManagedUser }>(`/users/${id}`, input);
  return data.user;
}

export async function impersonateUser(id: string): Promise<AuthUser> {
  const { data } = await apiClient.post<{ user: AuthUser }>(`/users/${id}/impersonate`);
  return data.user;
}

export async function exitImpersonation(): Promise<AuthUser | null> {
  const { data } = await apiClient.post<{ user: AuthUser | null }>("/users/exit-impersonation");
  return data.user;
}
